export class Notice {
    id?: number;
    title?: string;
    description?: string;
    status?: ('active'|'inactive');
    start_date?: string;
    end_date?: string

    created?: Date;
    updated?: Date;

    static fromJson(fields: any): Notice {
        let item = Object.assign(new this(), fields);

        return item;
    }
}
